module.exports = "<p>\n  email-templates works!\n</p>\n"